import { render, staticRenderFns } from "./BSMono.vue?vue&type=template&id=342a8bc9"
import script from "./BSMono.vue?vue&type=script&lang=js"
export * from "./BSMono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports